import { render, staticRenderFns } from "./ListBarang.vue?vue&type=template&id=68b96f68&scoped=true&"
import script from "./ListBarang.vue?vue&type=script&lang=js&"
export * from "./ListBarang.vue?vue&type=script&lang=js&"
import style0 from "./ListBarang.vue?vue&type=style&index=0&id=68b96f68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b96f68",
  null
  
)

export default component.exports